import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';

import type { Appointment } from '@/react-query/useAppointments';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

interface GenerateClaimAttachmentButtonProps {
  appointment: Appointment;
  variant?: 'default' | 'outline';
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

interface AppointmentWithTreatments extends Appointment {
  treatments?: Array<{ txCode: string }>;
}

export const GenerateClaimAttachmentButton = ({
  appointment,
  variant = 'default',
  onClick,
}: GenerateClaimAttachmentButtonProps) => {
  const { t } = useLingui();

  // selectedTreatmentCodes is currently [], pass codes directly from appointment instead
  const appointmentTreatmentCodes =
    (appointment as AppointmentWithTreatments)?.treatments?.map(
      (tx) => tx.txCode,
    ) || [];

  const { trackEvent } = useTrackEvent();

  return (
    <Button
      name="Generate Claim Attachment"
      title={t`Generate Claim Attachment`}
      data-cy={`customize-button-${appointment?.appointment.unifiedId}`}
      variant={variant}
      onClick={(e) => {
        trackEvent(mixpanelEvents.viewAttachment, {
          unifiedId: appointment.appointment.unifiedId,
          estimatedVisitId: appointment.appointment.estimatedVisitId,
          txCode: appointmentTreatmentCodes,
        });
        onClick(e);
      }}
    >
      <FontAwesomeIcon
        icon={faFileLines}
        className="vai-inline xl:vai-hidden"
      />
      <span className="vai-hidden xl:vai-inline">{t`Review Attachment`}</span>
    </Button>
  );
};
